import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, VideoStartResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';
import { getFormattedOriginalSourcePage } from '../utils';

export const mapVideoStart = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): VideoStartResult => {
    const assetDuration = payload.payload.duration;
    const progressPct = Math.round(parseFloat(payload.payload.percentOfPlayback.toFixed(2)));
    return {
        ...mapBase(payload),
        action: EVENTS.VIDEO_START,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        duration: assetDuration,
        progress_pct: progressPct,
        source_page: getFormattedOriginalSourcePage(payload),
        source_rail: payload.payload.asset.sectionLabel,
    };
};
